import { render } from "./Headphones.vue?vue&type=template&id=58ff7fc6&scoped=true"
import script from "./Headphones.vue?vue&type=script&lang=js"
export * from "./Headphones.vue?vue&type=script&lang=js"

import "./Headphones.vue?vue&type=style&index=0&id=58ff7fc6&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/simple-city-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ff7fc6"]])

export default __exports__